import { decamelize } from "humps"
import {
  put, post, del, get,
} from "services/api"
import { currentAccountId } from "services/authentication"
import {
  Account,
  PaginationMeta,
  AccountUser,
  User,
  AccountConfiguration,
} from "../sharedTypes"
import {
  PostAccount,
  PutAccount,
  CheckPassword,
  PutCurrentUser,
  PutUpdatePassword,
} from "../sharedTypes/api"

export const postAccount = (data: PostAccount) => post<Account>(`${import.meta.env.VITE_API_BASE}/api/v2/accounts.json`, data)

export const putAccount = (data: PutAccount) => put<Account>(`${import.meta.env.VITE_API_BASE}/api/v2/accounts/${currentAccountId()}.json`, data)

export const deleteAccount = () => del<Account>(`${import.meta.env.VITE_API_BASE}/api/v2/accounts/${currentAccountId()}.json`)

export const checkPassword = (data: CheckPassword) => post<{passed: boolean}>(`${import.meta.env.VITE_API_BASE}/api/v2/users/check_password.json`, data)

export const putCurrentUser = (data: PutCurrentUser) => put<User>(`${import.meta.env.VITE_API_BASE}/api/v2/users.json`, data)

export const putUpdatePassword = (data: PutUpdatePassword) => put<User>(`${import.meta.env.VITE_API_BASE}/api/v2/user/update_password.json`, data)

export const cancelSubscription = (data?: { option?: string; text?: string }) => del(`${import.meta.env.VITE_API_BASE}/api/v2/${currentAccountId()}/subscription.json`, data)

export const createBillingPortalSession = (data?: { flow?: string; stripePriceId?: string }) => post<{url: string}>(`${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/billing_portal_sessions.json`, data)

export const createCheckoutSession = (data: { stripePriceId: string }) => post<{session_id: string; url: string}>(`${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/checkout_sessions.json`, data)

export const getPlans = () => get(`${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/plans.json`)

export const getAccountUsers = () => get<{ data: AccountUser[], meta: PaginationMeta }>(`${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/team_members.json`)

export const postAccountUser = (accountUser: Partial<AccountUser>) => post<{ data: AccountUser }>(`${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/team_members.json`, { teamMember: accountUser })

export const postAccountUserDirect = (data: Record<string, any>) => {
  const url = `${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/users.json`

  if (data.photo instanceof File) {
    const formData = new FormData()
    Object.entries(data).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(`user[${decamelize(key)}]`, value as string | Blob)
      }
    })
    return post<{ data: AccountUser }>(url, formData)
  }

  return post<{ data: AccountUser }>(url, { user: data })
}

export const putAccountUser = (data: AccountUser & Record<string, any>) => {
  const url = `${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/team_members/${data.id}.json`

  if (data.photo instanceof File) {
    const { user, events, ...rest } = data
    const formData = new FormData()
    Object.entries(rest).forEach(([key, value]) => {
      if (value === null || value === undefined) return
      if (value instanceof File || !(value instanceof Object)) {
        formData.append(`team_member[${decamelize(key)}]`, value instanceof File ? value : String(value))
      }
    })
    return put<{ data: AccountUser }>(url, formData)
  }

  return put<{ data: AccountUser }>(url, data)
}

export const deleteAccountUser = (data: AccountUser) => del(`${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/team_members/${data.id}.json`)

export const getConfiguration = () => get<AccountConfiguration>(`${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/configuration.json`)

export const deleteOrphanContacts = () => del<{ count: number }>(`${import.meta.env.VITE_API_BASE}/api/v2/accounts/${currentAccountId()}/orphan_contacts.json`)

export const postExportAccount = () => post(`${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/export.json`)
